var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"nav-buttons"},[_vm._t("default",function(){return [_c('li',{staticClass:"nav-button-item"},[_c('router-link',{attrs:{"to":{ name: 'settings' }}},[_vm._v("Settings")])],1),_c('li',{staticClass:"nav-button-item"},[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About")])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }